module.exports = __webpack_public_path__ + "static/media/sai-de-silva-httxBNGKapo-unsplash.a61dafba.jpg";